/* MV 26 Oct 2026. Oz Hair style search for the header.
   Focus the bar: a panel opens with popular searches and products (full screen on phones).
   Type: suggestions and products from Shopify predictive search, rendered by
   sections/mv-search-results.liquid. Markup: sections/mv-search.liquid. Styles: assets/mv-search.css. */
(function () {
  'use strict';
  if (window.MvSearch) return;
  var MQ = window.matchMedia('(max-width: 989px)');
  var docEl = document.documentElement;
  var cache = {};

  function place(root) {
    var header = document.querySelector('header.header');
    if (!root || !header) return;
    if (root.parentNode !== header) {
      var heading = header.querySelector('.header__heading');
      if (heading && heading.parentNode === header) header.insertBefore(root, heading.nextSibling);
      else header.appendChild(root);
    }
    header.classList.add('mv-sb-on');
  }

  function init(root) {
    if (!root || root.mvSb) return;
    var input = root.querySelector('[data-mv-sb-input]');
    var form = root.querySelector('[data-mv-sb-form]');
    var panel = root.querySelector('[data-mv-sb-panel]');
    var results = root.querySelector('[data-mv-sb-results]');
    var foot = root.querySelector('[data-mv-sb-foot]');
    var all = root.querySelector('[data-mv-sb-all]');
    var tpl = root.querySelector('template[data-mv-sb-default]');
    var clearBtn = root.querySelector('[data-mv-sb-clear]');
    var closeBtn = root.querySelector('[data-mv-sb-close]');
    var scrim = root.querySelector('[data-mv-sb-scrim]');
    if (!input || !form || !panel || !results) return;
    var suggestUrl = root.getAttribute('data-suggest-url') || '/search/suggest';
    var searchUrl = root.getAttribute('data-search-url') || '/search';
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 6;
    var isOpen = false, timer = 0, ctrl = null, reqId = 0, current = null;

    function terms() { return input.value.replace(/\s+/g, ' ').trim(); }
    function allUrl(q) { return searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }

    function lock(on) {
      if (on) {
        var gap = window.innerWidth - docEl.clientWidth;
        if (gap > 0) docEl.style.setProperty('--mv-sb-sbw', gap + 'px');
        docEl.classList.add('mv-sb-lock');
      } else {
        docEl.classList.remove('mv-sb-lock');
        docEl.style.removeProperty('--mv-sb-sbw');
      }
    }

    function sizePanel() {
      if (MQ.matches) { panel.style.maxHeight = ''; return; }
      var wrap = root.closest('sticky-header') || root.closest('.header-wrapper') || root.parentNode;
      var bottom = wrap.getBoundingClientRect().bottom;
      panel.style.maxHeight = Math.max(260, window.innerHeight - bottom - 16) + 'px';
    }

    function showDefault() {
      if (current === '') return;
      current = '';
      results.innerHTML = '';
      if (tpl) results.appendChild(tpl.content.cloneNode(true));
      if (foot) foot.hidden = true;
      root.classList.remove('is-loading');
    }

    function render(markup, q) {
      if (terms() !== q || !isOpen) return;
      root.classList.remove('is-loading');
      results.innerHTML = markup;
      current = q;
      if (all) all.href = allUrl(q);
      if (foot) foot.hidden = false;
      panel.scrollTop = 0;
    }

    function fetchResults(q) {
      if (cache[q] !== undefined) { render(cache[q], q); return; }
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var id = ++reqId;
      root.classList.add('is-loading');
      if (all) all.href = allUrl(q);
      var url = suggestUrl + '?q=' + encodeURIComponent(q) + '&section_id=mv-search-results' +
        '&resources%5Btype%5D=product%2Cquery%2Ccollection&resources%5Blimit%5D=' + limit +
        '&resources%5Blimit_scope%5D=each&resources%5Boptions%5D%5Bunavailable_products%5D=last';
      fetch(url, ctrl ? { signal: ctrl.signal, credentials: 'same-origin' } : { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (text) {
          var box = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-mv-sbr]');
          if (!box) throw new Error('No results markup');
          cache[q] = box.innerHTML;
          if (id === reqId) render(cache[q], q);
        })
        .catch(function (err) {
          if ((err && err.name === 'AbortError') || id !== reqId) return;
          root.classList.remove('is-loading');
          if (terms() !== q) return;
          results.innerHTML = '<p class="mv-sb__none">Results are slow to load. Press Search to see everything for "' +
            q.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }) + '".</p>';
          current = null;
          if (foot) foot.hidden = false;
        });
    }

    function update() {
      var q = terms();
      if (clearBtn) clearBtn.hidden = input.value.length === 0;
      clearTimeout(timer);
      if (q.length < 2) {
        if (ctrl) ctrl.abort();
        reqId++;
        showDefault();
        return;
      }
      if (q === current) return;
      timer = setTimeout(function () { fetchResults(q); }, cache[q] !== undefined ? 0 : 180);
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      root.style.setProperty('--mv-sb-h', root.offsetHeight + 'px');
      root.classList.add('is-open');
      lock(true);
      panel.hidden = false;
      if (scrim) scrim.hidden = MQ.matches;
      input.setAttribute('aria-expanded', 'true');
      current = null;
      update();
      sizePanel();
      document.addEventListener('keydown', onKey, true);
      document.addEventListener('pointerdown', onPointer, true);
    }

    function close(blur) {
      if (!isOpen) return;
      isOpen = false;
      clearTimeout(timer);
      if (ctrl) ctrl.abort();
      reqId++;
      root.classList.remove('is-open', 'is-loading');
      root.style.removeProperty('--mv-sb-h');
      lock(false);
      panel.hidden = true;
      if (scrim) scrim.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKey, true);
      document.removeEventListener('pointerdown', onPointer, true);
      if (blur && root.contains(document.activeElement)) document.activeElement.blur();
    }

    function links() {
      return Array.prototype.filter.call(panel.querySelectorAll('a[href]'), function (a) {
        return a.offsetParent !== null || a.getClientRects().length > 0;
      });
    }

    function onKey(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        close(true);
        return;
      }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var list = links();
      if (!list.length) return;
      var i = list.indexOf(document.activeElement);
      if (document.activeElement === input) {
        if (e.key === 'ArrowDown') { e.preventDefault(); list[0].focus(); }
        return;
      }
      if (i === -1) return;
      e.preventDefault();
      if (e.key === 'ArrowDown') list[Math.min(i + 1, list.length - 1)].focus();
      else if (i === 0) input.focus();
      else list[i - 1].focus();
    }

    function onPointer(e) {
      if (MQ.matches || e.target === scrim) return;
      if (!root.contains(e.target)) close(false);
    }

    input.addEventListener('focus', open);
    input.addEventListener('click', open);
    input.addEventListener('input', update);
    root.addEventListener('focusout', function () {
      setTimeout(function () {
        if (isOpen && !MQ.matches && !root.contains(document.activeElement) && document.activeElement !== document.body) close(false);
      }, 0);
    });
    if (scrim) scrim.addEventListener('click', function () { close(false); });
    if (closeBtn) closeBtn.addEventListener('click', function () { close(true); });
    if (clearBtn) clearBtn.addEventListener('click', function () {
      input.value = '';
      update();
      input.focus();
    });
    form.addEventListener('submit', function (e) {
      if (!terms()) { e.preventDefault(); input.focus(); }
    });
    MQ.addEventListener ? MQ.addEventListener('change', function () { close(false); }) : MQ.addListener(function () { close(false); });
    window.addEventListener('resize', function () { if (isOpen) sizePanel(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) close(true); });
    root.mvSb = { open: open, close: close };
    if (clearBtn) clearBtn.hidden = input.value.length === 0;
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-mv-sb]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(function () {
      if (window.MvSbRoot && document.body.contains(window.MvSbRoot) === false) place(window.MvSbRoot);
      var h = document.querySelector('header.header');
      if (h && window.MvSbRoot && !h.contains(window.MvSbRoot)) place(window.MvSbRoot);
      initAll();
    }, 0);
  });

  window.MvSearch = { init: initAll, place: place };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();